import { Navigate, Route } from "react-router-dom";
import { ProfileSettingsScreen } from "./ProfileSettingsScreen";

export const routes = (
  <>
    <Route path="settings" element={<Navigate to="/settings/account" replace />} />
    <Route path="settings/account" Component={ProfileSettingsScreen} />
  </>
);
